'use client'

import { FadeInSlideUp } from '@/components/shared/animations'
import { NextImageWrapper } from '@/components/shared/NextImageWrapper'
import { useContentfulEntryLivePreview } from '@/components/providers/useContentfulEntryLivePreview'
import { ButtonEntry } from '@/components/templates/dynamic/button'
import type { Button as ButtonFieldsFragment, HeroFieldsFragment } from '@/graphql/types'
import { DynamicHero } from '@ccpgames/eve-web-core'
import styles from './Hero.module.css'

// Function to render CTA buttons from Contentful data
const renderCtaButtons = (items: ButtonFieldsFragment[]) => {
  if (!items || items.length === 0) {
    return null
  }

  // Render all CTA items from the collection
  return (
    <FadeInSlideUp delay={0.8}>
      <div className={styles.ctaContainer}>
        {items.map((cta) => (
          <ButtonEntry key={cta.sys.id} entry={cta} />
        ))}
      </div>
    </FadeInSlideUp>
  )
}

interface HeroProps {
  entry: HeroFieldsFragment
}

export function Hero({ entry }: HeroProps) {
  const { updatedEntry, inspectorProps } = useContentfulEntryLivePreview(entry)
  const ctaCollection = (updatedEntry?.ctaCollection?.items?.filter((item) => item !== null) ??
    []) as ButtonFieldsFragment[]

  return (
    <div {...inspectorProps('title')}>
      <DynamicHero
        title={updatedEntry?.title ?? null}
        subtitle={updatedEntry?.subtitle ?? null}
        backgroundVideoUrl={updatedEntry?.backgroundUrl ?? null}
        backgroundImage={
          updatedEntry?.background?.url ? (
            <NextImageWrapper
              fill
              priority
              sizes="100vw"
              src={updatedEntry.background.url}
              alt={updatedEntry.background.description ?? updatedEntry.background.title ?? ''}
              aria-hidden
            />
          ) : undefined
        }
        ctaContent={renderCtaButtons(ctaCollection)}
        overlay={0.4}
      />
    </div>
  )
}
